import React from 'react';
import '../../../style/itemDropdown.scss';

function ItemLocations({ gate, setLocation, setGate, type }) {
  const locations = [
    'Martlock',
    'Lymhurst',
    'Thetford',
    'FortSterling',
    'Bridgewatch',
    'Caerleon',
    'ArthursRest',
    'MorganasRest',
    'MerlynsRest',
  ];

  function closeLocationDropdown(value) {
    if (type) {
      setGate(true);
      setLocation(type, value);
      return;
    }
    setGate(true);
    setLocation(value);
  }
  return (
    <>
      <div
        className={`dropdownCloser ${gate && 'hidden'}`}
        onClick={() => setGate(true)}
      ></div>
      <div className={`searchOptionSelections locations ${gate && 'hidden'}`}>
        {locations.map(location => (
          <p
            className={`${location} option`}
            onClick={() => {
              closeLocationDropdown(location);
            }}
          >
            {location}
          </p>
        ))}
      </div>
    </>
  );
}

export default ItemLocations;
